import React, { useMemo } from "react";
import { Grid, Segment } from "semantic-ui-react";
import { useTranslation } from "react-i18next";
import Typography from "components/atoms/Typography/Typography";
import { definedTypographyTypes } from "components/atoms/Typography/TypographyStyles";
import MediaRating from "components/organisms/MediaRating/MediaRating";

import { StyledOrganizationCard } from "../../../styles/CardStyles";
import { PLACEHOLDER_SQUARE } from "../../../images/imageSources";
import PlaceHoldableImage from "../Images/PlaceholdableImage";

interface Props {
  data: Record<string, any>;
}

const MediaSourceCard: React.FC<Props> = ({ data }) => {
  const { t } = useTranslation();
  const {
    imageUrl,
    title,
    seoDescription,
    slug,
    ratingTotal,
    url,
    ratingCount,
  } = data;

  const ratingDisplayed = useMemo(
    () => Math.round((ratingTotal || 5) / (ratingCount || 1)),
    [ratingTotal, ratingCount],
  );

  return (
    <Segment style={{ border: "none", padding: 0, boxShadow: "none" }}>
      <StyledOrganizationCard>
        <div id="image">
          <PlaceHoldableImage
            thumbnail
            fallbackImage={PLACEHOLDER_SQUARE}
            src={imageUrl}
            alt={title}
          />
        </div>
        <div id="content">
          <Grid columns={2}>
            <Grid.Column mobile={16} tablet={8} computer={10}>
              <a href={url} target="_blank" rel="noopener noreferrer">
                <Typography type={definedTypographyTypes.h2} margin="0">
                  {title}
                </Typography>
              </a>
              <p>{seoDescription}</p>
            </Grid.Column>

            <Grid.Column mobile={16} tablet={8} computer={6}>
              <Typography type={definedTypographyTypes.h3} margin="0">
                {t("YourRating")}
              </Typography>
              <MediaRating mediaSourceId={slug} />
              <Typography type={definedTypographyTypes.h3} margin="1em 0 0 0">
                {t("AverageRating")}
              </Typography>
              <Typography type={definedTypographyTypes.h1} margin="0">
                {Number(ratingDisplayed) ? `${ratingDisplayed} / 5 ` : "-"}
              </Typography>
            </Grid.Column>
          </Grid>
        </div>
      </StyledOrganizationCard>
    </Segment>
  );
};

export default MediaSourceCard;
